import { ElMessage, ElNotification } from 'element-plus';
import JsEncrypt from 'jsencrypt';

export const rsaEncrypt = str => {
  const jse = new JsEncrypt();
  jse.setPublicKey(
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDf+FF5dSfjeg/cQQBAYymJZM7zOa3XdIuf/oHqBXxGpIK7aD1t8NXKydkp9xdVJP03Nn7h+Nwnbg9VWUf7peIPs3t7dJl8D3KNlt+2VExi3uYIY74kOKnU/LL03KWO8tVxKzVOqIWAXaZaj6foeAJr+UuClKzme/eHTrzofhoxEwIDAQAB'
  );
  return jse.encrypt(str);
};
/**
 * 在树型数据结构中通过key值获取节点信息
 * @param {string} key
 * @param {string|number} value
 * @param {array} treeData
 * @returns
 */
export const getTreeNodeInfoByKey = (key, value, treeData) => {
  if (key !== undefined && value !== undefined && treeData?.length) {
    for (const item of treeData) {
      if (item[key] === value) {
        return item;
      }
      if (item.children) {
        const fundItem = getTreeNodeInfoByKey(key, value, item.children);
        if (fundItem) return fundItem;
      }
    }
    return null;
  }
  return null;
};
export const getUuid = () => {
  const s: Array<string> = [];
  const hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4';
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);

  const uuid = s.join('');
  return uuid;
};
export const confirm = (message?: string) => {
  return new Promise<void>((resolve, reject) => {
    ElMessageBox.confirm(message || '确定删除该数据吗？', '提示', {
      confirmButtonText: '确 定',
      cancelButtonText: '取 消',
      type: 'warning',
    })
      .then(() => {
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
};

export type TreeNode = {
  children?: TreeNode[];
  [key: string]: any;
};
export const flatTree = (nodes: TreeNode[]): TreeNode[] => {
  return nodes.reduce<TreeNode[]>((acc, node) => {
    acc.push(node); // 添加当前节点
    if (node.children) {
      acc.push(...flatTree(node.children)); // 递归拍平子节点
    }
    return acc;
  }, []);
};
export const deepLoopTree = (list: TreeNode[]): TreeNode[] => {
  list.forEach(item => {
    item.uuid = item.eid + item.type;
    // item.value = getUuid();
    deepLoopTree(item.children ?? []);
  });
  return list;
};
export const message = (message, type?: string) => {
  ElMessage({
    message: message || '操作成功',
    type: type || 'success',
  });
};
export const notify = (message, type?: string) => {
  ElMessage({
    message: message || '操作成功',
    type: type || 'success',
  });
};
export const formatJSAsHTML = jsText => {
  jsText = jsText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const html = jsText
    .split('\n')
    .map(function (line) {
      return '<pre>' + line + '</pre>';
    })
    .join('');

  return '<code>' + html + '</code>';
};

export const formatJSON = jsonText => {
  let formattedJSON = '';
  let indentLevel = 0;
  for (let i = 0; i < jsonText.length; i++) {
    const char = jsonText.charAt(i);
    if (char == '{' || char == '[') {
      formattedJSON += char + '\n' + ' '.repeat(indentLevel * 2 + 2);
      indentLevel++;
    } else if (char == '}' || char == ']') {
      indentLevel--;
      formattedJSON += '\n' + ' '.repeat(indentLevel * 2) + char;
    } else if (char == ',') {
      formattedJSON += char + '\n' + ' '.repeat(indentLevel * 2);
    } else {
      formattedJSON += char;
    }
  }
  return formattedJSON;
};

/**
 * 是否为空
 * @param {*} val
 * @example isEmpty(undefined) => true
 * @example isEmpty(null) => true
 * @example isEmpty('') => true
 * @example isEmpty(NaN) => true
 * @example isEmpty([]) => true
 * @example isEmpty({}) => true
 * @example isEmpty(0) => false
 */
export const isEmpty = (val: any) => {
  if (val === 0) return false;
  if (val === undefined || val === null) return true;
  if (Number.isNaN(val)) return true;
  if (Array.isArray(val) || typeof val === 'string') return val.length === 0;
  if (Object.prototype.toString.call(val) === '[object Object]') {
    for (const key in val) {
      if (Object.prototype.hasOwnProperty.call(val, key)) {
        return false;
      }
    }
    return true;
  }
  return false;
};

/**
 * 校验图片是否符合要求
 * @param file 文件对象
 * @param opts 校验选项
 * @param opts.maxSize 最大图片大小，默认200 * 1024即200K
 * @param opts.label 图片标签，默认'图片'
 */
export const validateImg = async (file, opts?: { maxSize?: number; label?: string }) => {
  const maxSize = opts?.maxSize || 200 * 1024;
  const label = opts?.label || '图片';
  if (file.size > maxSize) {
    const msg = `${label}大小不能超过${parseInt(String(maxSize / 1024))}K`;
    ElMessage.warning(msg);
    throw new Error(msg);
  }
};

export default {
  notify(message, type?: any) {
    ElNotification({
      title: '提示',
      message: message,
      type: type || 'success',
    });
  },

  replaceObjProperty(target, source) {
    if (
      Object.prototype.toString.call(target) === '[object Object]' &&
      Object.prototype.toString.call(source) === '[object Object]'
    ) {
      Object.keys(target).forEach(a => {
        if (source.hasOwnProperty(a)) {
          target[a] = source[a];
        }
      });
    }
    return target;
  },
  confirm(message, callback) {
    ElMessageBox.confirm(message, '提示', {
      confirmButtonText: '确 定',
      cancelButtonText: '取 消',
      type: 'warning',
    })
      .then(() => {
        try {
          callback();
        } catch {
          console.log(`${typeof callback} is not a function`);
        }
      })
      .catch(() => {
        //
      });
  },
  // 防抖
  debounce(func, wait) {
    let timeout;
    /*eslint-disable*/
    return function () {
      let context = this;
      let args = arguments;

      if (timeout) clearTimeout(timeout);

      let callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, wait);

      if (callNow) func.apply(context, args);
    };
  },
  throttle(fn, delay = 50) {
    let originTime = new Date().getTime();
    /*eslint-disable*/
    return function () {
      let args = arguments;
      let currentTime = new Date().getTime();
      if (currentTime - originTime > delay) {
        fn.apply(this, args);
        originTime = currentTime;
      }
    };
  },
  downloadBlob(response) {
    const { headers, data: arraybufferData } = response;
    if (Object.prototype.toString.call(arraybufferData) === '[object Object]') {
      if (!arraybufferData.IsSuccess) {
      }
    }

    const url = window.URL.createObjectURL(
      new Blob([arraybufferData], {
        type: headers['content-type'],
      })
    );

    const fileName = decodeURIComponent(headers['content-disposition'].split('filename=')[1]);

    this.downloadFile(url, fileName);
  },
  downloadFile(url, name = '') {
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  formatCurrency(num, digit = 2) {
    if (num == '0') return 0;
    if (!num) return '';
    let zero = '';
    for (let i = 0; i < digit; i++) {
      zero += '0';
    }
    /*eslint-disable*/
    let c =
      num.toString().indexOf('.') !== -1
        ? num.toLocaleString('zh', {
            minimumFractionDigits: digit || 2,
            maximumFractionDigits: digit || 2,
          })
        : digit === 0
        ? num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + zero;
    return c;
  },
  // 处理成千分位并且fixtoTwo
  milliFormatFixedTwo(input, isFixedTwo = true) {
    const DIGIT_PATTERN = /(^|\s|(-)?)\d+(?=\.?\d*($|\s))/g;
    const MILLI_PATTERN = /(?=(?!\b)(\d{3})+$)/g;
    let res = input.toString();
    if (input) {
      if (isFixedTwo) {
        if (parseInt(input) !== input) {
          input = Number(input).toFixed(2);
        }
      }
      res = input.toString().replace(DIGIT_PATTERN, m => m.replace(MILLI_PATTERN, ','));
    }
    if (!res.includes('.')) res += '.00';
    return res;
  },
  /**
   * 金额表示 数字加逗号 （小数处理）
   * @returns {string | any}
   * @param num
   * @param digits
   */
  milliFormatDigits(num, digits = 2) {
    if (isNaN(+num)) return num;
    if (!num && num !== 0) {
      return num;
    }
    return (+num || 0).toFixed(digits).replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
  },
  /**
   * 金额表示 数字加逗号 （不处理小数）
   * @param num
   * @returns {string | any}
   */
  milliFormatInt(num) {
    if (isNaN(+num)) return num;
    if (!num && num !== 0) {
      return num;
    }
    return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
  },
  /**
   * 金额分割符(残次）
   * @param input
   * @returns {string}
   */
  milliFormat(input) {
    const DIGIT_PATTERN = /(^|\s)\d+(?=\.?\d*($|\s))/g;
    const MILLI_PATTERN = /(?=(?!\b)(\d{3})+$)/g;

    return input && input.toString().replace(DIGIT_PATTERN, m => m.replace(MILLI_PATTERN, ','));
  },
};
